import { v4 } from "uuid";

export class PivotsHarnessController {
  public pivots: any[];
  public largePivots: any[];
  public activePivotId: any;
  // @ngInject
  constructor(private $timeout: ng.ITimeoutService, private $scope: ng.IScope) {
    this.pivots = [
      {
        name: "Thing1Thing1Thing1Thing1",
        uniqueId: "Thing1",
        biId: "Pivot Harness 1",
        isCloseable: true,
        automationId: "pivot-harness-first"
      },
      {
        name: "Thing2Thing2Thing2",
        uniqueId: "Thing2",
        automationId: "pivot-harness-second"
      }
    ];

    this.largePivots = [
      {
        name: "Thing1Thing1Thing1Thing1",
        uniqueId: "Thing1",
        biId: "Pivot Harness 1",
        isCloseable: true
      },
      {
        name: "Thing2Thing2Thing2",
        uniqueId: "Thing2"
      },
      {
        name: "Thing3Thing3",
        uniqueId: "Thing3",
        isCloseable: true
      },
      {
        name: "Thing4",
        uniqueId: "Thing4"
      },
      {
        name: "Thing5Thing5Thing5Thing5Thing5Thing5Thing5",
        uniqueId: "Thing5",
        isCloseable: true
      },
      {
        name: "Thing6Thing6",
        uniqueId: "Thing6"
      },
      {
        name: "Thing7Thing7",
        uniqueId: "Thing7",
        isCloseable: true
      },
      {
        name: "Thing8Thing8Thing8Thing8",
        uniqueId: "Thing8"
      },
      {
        name: "Thing9Thing9Thing9Thing9",
        uniqueId: "Thing9",
        isCloseable: true
      },
      {
        name: "Thing10Thing10",
        uniqueId: "Thing10",
        isCloseable: true
      }
    ];
  }

  $onInit() {
    this.activePivotId = "Thing1";
  }

  public pivotSelected(pivot: any): void {
    console.info(pivot.name + " was selected.");
  }

  public getPivotId(pivot: ng.IScope): void {
    return pivot.pivot.uniqueId;
  }

  public getPivotText(pivot: any): string {
    return pivot ? pivot.name + pivot.uniqueId : "";
  }

  public addPivot() {
    this.$scope.$evalAsync(() => {
      let uniqueId = v4();
      this.pivots.push({ name: uniqueId, uniqueId: uniqueId });
    });
  }

  public removePivot() {
    this.$scope.$evalAsync(() => {
      this.pivots.splice(this.pivots.length - 1, 1);
    });
  }
}
